

export default {
  // Letter output format (admin only).
  letter_format: 'صيغة الخطاب',
  format_pdf: 'PDF',
  format_word: 'Word',
  format_word_hint: 'يُسلَّم الخطاب ملف وورد قابلاً للتعديل.',
  format_word_html_hint: 'هذا القالب مبني على محرر الخطابات لا على ملف وورد: النص والقيم والجداول تصل كاملة، لكن صورة الخلفية وموضع الختم وحدود الجدول تختلف عن الـPDF.',
  // Letters system (نظام الخطابات) — page titles + actions
  'letter-template-index': 'قوالب الخطابات',
  'issued-letter-index': 'الخطابات الصادرة',
  issue: 'إصدار',
  issue_letter: 'إصدار خطاب',
  select_claim: 'اختر المطالبة',
  select_template: 'اختر القالب',
  letter_preview: 'معاينة الخطاب',
  view_pdf: 'عرض الـ PDF',
  download_pdf: 'تحميل الـ PDF',
  remove_stamp: 'حذف الختم',
  no_active_template: 'لا يوجد قالب مفعّل مرتبط بهذا العميل',
  issued_for_owner: 'المالك',
  issued_for_driver: 'السائق',
  issued_for_both: 'المالك والسائق',
  use_single_text: 'حقل نص واحد',
  use_single_text_hint: 'يخفي التحية والموضوع ونص الخطاب والخاتمة والتذييل، ويظهر حقلاً واحداً يمكن كتابة أي شيء فيه مع تنسيق الكلام.',
  insert_field: 'إدراج حقل',
  insert_field_hint: 'اضغط داخل الحقل المطلوب ثم اختر الحقل ليُدرج في موضع المؤشر.',
  show_table: 'إظهار في جدول',
  show_table_hint: 'عند إزالة العلامة تظهر البيانات كما هي بدون رسم الجدول وحدوده.',
  select_all: 'تحديد الكل',
  select_none: 'إلغاء تحديد الكل',
  save_all_tabs_hint: 'الحفظ يشمل جميع التبويبات معاً.',
  discount_rules_empty: 'لم تُضَف سنوات بعد — بدون سنة مسجّلة لا يوجد حد أقصى للخصم.',
  template_source: 'مصدر القالب',
  template_source_hint: 'إما تجهيز الخطاب من خلال النموذج، أو رفع ملف Word جاهز يُملأ ويُحوَّل إلى PDF عند الإصدار.',
  source_builder: 'النموذج الجاهز',
  source_docx: 'ملف Word',
  tab_word: 'ملف Word',
  docx_file: 'ملف القالب (docx)',
  docx_hint: 'صيغة docx فقط، بحد أقصى 10 ميجابايت. الملف يحدد شكل الخطاب بالكامل (الترويسة والتذييل والختم والجداول).',
  docx_save_first: 'احفظ القالب أولاً، ثم ارفع ملف Word.',
  docx_remove: 'حذف الملف',
  docx_found: 'الحقول التي سيتم استبدالها',
  docx_found_none: 'لم يُعثر على أي حقل معروف داخل الملف.',
  docx_split: 'حقول لن يتم استبدالها',
  docx_split_fix: 'هذه الحقول جزّأها Word داخلياً وتعذّر لَمُّها تلقائياً — غالباً لوجود فاصل سطر أو فقرة داخل الحقل نفسه. احذف الحقل من ملف Word وألصقه مرة واحدة (نسخ ولصق وليس كتابة).',
  docx_unknown: 'حقول غير معروفة ستبقى كما هي في الخطاب:',
  docx_tokens_reference: 'الحقول المتاحة',
  docx_tokens_reference_hint: 'اضغط على أي حقل لنسخه، ثم الصقه داخل ملف Word في المكان المطلوب.',
  copy_token: 'اضغط للنسخ',
  token_copy_failed: 'تعذّر النسخ، انسخ الحقل يدوياً.',
  docx_issue_hint: 'شكل الخطاب يأتي من ملف Word؛ هذه هي القيم التي ستُدرج فيه.',
  docx_missing_template: 'لم يُرفع ملف Word لهذا القالب، لا يمكن إصدار الخطاب.',
  user_note_docx_hint: 'قالب Word: تُدرج الملاحظات كنص فقط (مع الأسطر) بتنسيق الفقرة الموجودة في الملف.',
  tab_general: 'البيانات الأساسية',
  tab_content: 'نص الخطاب',
  tab_fields: 'الحقول الظاهرة',
  tab_discount: 'الخصم',
  tab_images: 'الصور',
  admin_only: 'إظهار فقط للإدارة',
  admin_only_hint: 'عند التحديد لا يظهر هذا القالب عند إصدار خطاب إلا للأدمن.',
  requires_approval: 'يتطلب تعميد',
  requires_approval_hint_template: 'عند التحديد لا يُنشأ الخطاب عند إصداره، بل يُرسل طلب تعميد إلى الإدارة، وبعد التعميد يستطيع المستخدم تحميله.',
  requires_approval_hint: 'هذا القالب يتطلب تعميد الإدارة: سيُرسل طلب التعميد ولن يُنشأ الخطاب حتى يتم اعتماده.',
  request_approval: 'إرسال طلب تعميد',
  approve_letter: 'تعميد الخطاب',
  cancel_letter: 'إلغاء الخطاب',
  replicate_template: 'نسخ القالب',
  header_hint: 'الترويسة تُطبع قبل أي شيء آخر في الخطاب (قبل الشعار والتاريخ). اتركها فارغة إن لم تكن مطلوبة.',
  user_note_hint: 'نص حر منسّق يظهر في المكان الذي أُدرج فيه حقل «ملاحظات المستخدم» داخل نصوص القالب، ولا يظهر شيء إن تُرك فارغاً.',
  download_failed: 'تعذّر تحميل الملف.',
  view_letter: 'عرض الخطاب',
  // The claim's money in the claim-actions dialog.
  claimFinancials: {
    button: 'إضافة خصم',
    title: 'خصم المطالبة',
    // What تفاصيل المطالبات and إدارة المطالبات call claim_amount, to set it
    // apart from the figure after the discount.
    base_amount: 'المبلغ الأساسي',
    discount: 'نسبة الخصم',
    after_discount: 'قيمة المطالبة بعد الخصم',
    paid: 'قيمة المبلغ المسدد',
    remaining: 'قيمة المبلغ المتبقي',
    hint: 'نسبة مئوية من 0 إلى 100. اترك الحقل فارغاً لإلغاء الخصم.',
    saved: 'تم حفظ الخصم',
    save_failed: 'تعذّر حفظ الخصم',
  },
  field_labels: 'تسميات الحقول',
  field_labels_hint: 'اترك الخانة فارغة لاستخدام التسمية الافتراضية، أو اكتب تسمية خاصة بهذا القالب (مثال: «رقم هوية العميل» بدل «رقم الهوية»).',
  allow_discount: 'إضافة خصم',
  allow_discount_hint: 'عند إزالة العلامة لا يُسمح للمستخدم بإدخال خصم عند إصدار الخطاب.',
  add_discount_rule: 'إضافة سنة',
  footer_hint: 'يُطبع في أسفل كل صفحة من الخطاب (في الوضعين: الحقول المنفصلة أو حقل النص الواحد).',
  format_painter: 'نسخ التنسيق',
  insert_table: 'إدراج جدول',
  table_rows: 'الصفوف',
  table_cols: 'الأعمدة',
  table_add_row: 'إضافة صف',
  table_add_col: 'إضافة عمود',
  table_del_row: 'حذف صف',
  table_del_col: 'حذف عمود',
  table_width: 'عرض الجدول',
  table_width_full: 'بعرض الصفحة',
  table_width_center: 'توسيط',
  table_width_auto: 'حسب المحتوى',
  table_fill: 'لون خلفية الجدول',
  table_fill_none: 'بدون لون',
  table_scope_cell: 'خلية',
  table_scope_row: 'سطر',
  table_scope_col: 'عمود',
  table_scope_table: 'الجدول',
  stamp_align: 'محاذاة الختم',
  stamp_align_hint: 'يُطبع الختم فوق التذييل مباشرة؛ هذا الخيار يحدد موضعه بعرض الصفحة فقط.',
  stamp_align_auto: 'تلقائي',
  stamp_align_right: 'يمين',
  stamp_align_center: 'وسط',
  stamp_align_left: 'يسار',
  pick_color: 'اختيار لون',
  insert_image: 'إدراج صورة',
  remove_background: 'حذف الخلفية',
  remove_logo: 'حذف الشعار',
  logo_hint: 'يُطبع في أعلى الخطاب بعرض الصفحة كاملاً بدون ضغط. المقاس المفضّل نحو 1400×300 بكسل (PNG شفاف).',
  background_hint: 'تصبح خلفية لكامل صفحة الخطاب. المقاس المفضّل A4 عمودي نحو 1240×1754 بكسل.',
  stamp_hint: 'يُطبع أسفل الخطاب. المقاس المفضّل نحو 600×330 بكسل (PNG شفاف).',
  insert_link: 'إضافة رابط',
  link_url: 'الرابط',
  remove_link: 'إزالة الرابط',
  discount_max_hint: 'الحد الأقصى للخصم لهذه السنة',
  discount_free_hint: 'لا يوجد حد أقصى للخصم لسنة هذه المطالبة',
  q: '؟',
  sar: 'ريال',
  false: 'معطل',
  true: 'مفعل',
  progress: 'جارٍ...',
  id: '#',
  file_id: 'معرف الملف',
  placeholder_example: 'مثال: السنة-الشهر ',
  ar: 'العربية',
  en: 'English',
  login: 'تسجيل الدخول',
  home: 'الرئيسية',
  mainScreenHome: 'تفاصيل المطالبات',
  medicalMainScreenHome: 'متابعة المطالبات',
  carMainScreenHome: 'تفاصيل المطالبات',
  policyMainScreenHome: 'تفاصيل الوثائق',
  legalMainScreenHome: 'شاشة المتابعة',
  done: 'موافق',
  logout: 'تسجيل الخروج',
  cancel: 'إلغاء',
  yes: 'نعم',
  no: 'لا',
  enabled: 'مفعل',
  disabled: 'معطل',
  save: 'حفظ',
  the_number: 'العدد',
  change: 'تعديل',
  options: 'خيارات',
  create: 'إضافة',
  store: 'إضافة',
  update: 'تعديل',
  upload: 'رفع',
  approval: 'تعميد',
  show_notes: 'ملاحظات الموظفين',
  car_claim_status_row_arrang: 'إعادة الاسناد',
  lastassign: 'اخر اسناد',
  showhistory: 'عرض السجل',
  claim_history: 'سجل المطالبة',
  assign: 'إسناد المطالبة',
  no_assign: 'إلغاء اسناد المطالبة',
  link_to_invoice: 'ربط بفاتورة',
  link_to_bill: 'ربط مطالبات',
  link_to_bill2: 'ربط أقساط',
  unlink: 'إلغاء الربط',
  final_total: 'الاجمالي',
  erp_bill_final_total: 'من المالية - الاجمالي',
  erp_bill_total: 'من المالية - المفوتر',
  erp_bill_vat: 'من المالية - الضريبة',
  car_bill_final_total: 'من المركبات - الاجمالي',
  car_bill_total: 'من المركبات - المفوتر',
  car_bill_vat: 'من المركبات - الضريبة',
  bill: 'فاتورة',
  is_closed: 'مغلقة',
  is_paid: 'مدفوعة',
  is_posted: 'مرحلة',
  debt_date: 'تاريخ المديونية',
  debt_date2: 'عمر المديونية',
  client_close_date: 'تاريخ الإغلاق',
  client_update_date: 'تاريخ التحديث',
  claims_count: 'المطالبات',
  bills_count: 'الفواتير',
  installments_count: 'الأقساط',
  start_from: 'الأيام من',
  end_to: 'الأيام إلى',
  percentage: 'النسبة',
  rows_count: 'الإجراءات',
  assign_date: 'تاريخ الإسناد',
  assigned_to: 'مسندة إلى',
  last_installment_date: 'تاريخ سداد اخر قسط',
  last_status_date: 'تاريخ اخر اجراء',
  car_assigned_to_tonum: 'مسندة إلى',
  pocket_claims: 'المحفظة',
  received_claims: 'المستلمة',
  assigned_claims: 'المسندة',
  notification_claims25: 'قيد التذكير',
  notification_claims39: 'العميل لديه موعد سداد',
  notification_claims40: 'العميل لا يرد',
  notification_claims41: 'العميل يرغب بالسداد',
  notification_claims44: 'متابعة ايجابية',
  notification_claims45: 'متابعة سلبية',
  paid_claims: 'المسددة',
  paid: 'المسدد',
  unposted: 'الغير مرحل',
  unpaid_amount: 'الغير مسدد',
  unbilled_amount: 'الغير مفوتر',
  closed_claims: 'المقفلة',
  pending_claims: 'بانتظار التعميد',
  approve_claims: 'تعميد',
  reassign_claims: 'إعادة إسناد',
  noassign_claims: 'المطالبات الغير المسندة',
  entry_required_claims: 'مطالبات مطلوب إدخالها',
  assign_update: 'تحديث الاسناد',
  assign_status: 'حالة الاسناد',
  arrange_claims: 'إدارة المطالبات',
  finance_claims: 'المتابعة المالية',
  finance_claim: 'نسبة العمولة',
  notification_claims: 'تذكير',
  suspend_claims: 'المعلقة',
  placed_claims: 'المقدمة',
  collected_claims: 'المحصلة',
  collected_amount: 'المبلغ المحصل',
  collected_amounts: 'المبالغ المحصلة',
  claim_claims: 'مطالبة/ات',
  inprogress_claims: 'تحت الإجراء',
  placeto_claims: 'مرفوعة للجان',
  installment_claims: 'التقسيط',
  month_target: 'بدء / انتهاء المستهدف الشهري',
  today_rows: 'عدد متابعات اليومية',
  download: 'تحميل',
  download_template: 'تحميل القالب',
  control: 'تحكم',
  none: 'لا يوجد',
  file_details: 'تفاصيل المرفق',
  file_desc: 'عنوان المرفق',
  file_name: 'اسم الملف',
  file_belong: 'مرفق تابع لـ',
  size: 'الحجم',
  files: 'مرفقات المستند',
  accident_files: 'مرفقات الحادث',
  created_at: 'تاريخ الانشاء',
  updated_at: 'تاريخ التعديل',
  uploaded_at: 'وقت الرفع',
  na: 'بدون',
  destroy: 'حذف',
  delete: 'حذف',
  show: 'عرض',
  subs: 'حقول الحالة',
  view: 'عرض',
  export: 'تصدير',
  close: 'إغلاق',
  edit: 'تعديل',
  add: 'إضافة',
  employee_notes: 'ملاحظات للموظف',
  employee_note: 'ملاحظة للموظف',
  step_texts: 'خطوات التنفيذ',
  step_text: 'تفاصيل خطوة التنفيذ',
  note_date: 'تاريخ الملاحظة',
  step_date: 'تاريخ التنفيذ',
  register: 'تسجيل',
  print: 'طباعة',
  today: 'اليوم',
  day: 'اليوم',
  daydays: 'يوم/أيام',
  date: 'التاريخ',
  now: 'الآن',
  am: 'ص',
  pm: 'م',
  error: 'خطأ !!',
  search: 'بحث',
  username: 'المستخدم',
  the_search: 'البحث',
  ByClient: 'المطالبات حسب العميل',
  ByUser: 'المطالبات المسندة حسب المستخدم',
  contract_count: 'عدد العقود',
  claimscount: 'عدد المطالبات',
  exportPdf: 'تصدير البيانات PDF',
  exportExcel: 'تصدير البيانات Excel',
  ImportExcelUpdateNumber: 'تحديث بيانات',
  ImportExcel: 'استيراد البيانات من Excel',
  assign_claims: 'اسناد المطالبات',
  assign_claims_rece: 'اسناد المطالبات مستلمة',
  search_claims: 'بحث بالوثيقة ملف اكسل',
  policy_count_found: 'عدد ارقام الوثائق المدخلة: <b>{0}</b>',
  clear_search_claims: 'الغاء البحث بالمطالبات',
  tele_search_claims: 'البحث من ملف اكسل',
  tele_search_count_found: 'عدد الارقام المدخلة: <b>{0}</b>',
  tele_clear_search_claims: 'الغاء البحث',
  message_body: 'نص الرسالة',
  sms_messages: 'الرسائل',
  send_sms: 'ارسال SMS',
  send_wa: 'ارسال واتساب',
  send_twilio_wa: 'ارسال واتساب Twilio',
  car_wa_template_index: 'قوالب رسائل الواتساب',
  car_wa_template: 'قالب واتساب',
  wa_template_placeholder: 'اكتب نص الرسالة هنا...',
  wa_template_vars_hint: '',
  msgtext: 'نص الرسالة',
  select_wa_template: 'اختر قالب الرسالة',
  det_sms: 'رصيد',
  assign_parties: 'اسناد الإجراءات',
  refreshTable: 'تحديث الصفحة',
  refreshData: 'تحديث البيانات',
  getData: 'جلب البيانات',
  expansionPanelHeaderOptions: 'الأدوات',
  close_window: 'اغلاق النافذة',
  year: 'سنة',
  showDetails: 'عرض التفاصيل',
  Details: 'تفاصيل ',
  theDetails: 'التفاصيل',
  information: 'معلومات ',
  the_information: 'المعلومات ',
  setting: 'الضبط',
  month: 'شهر',
  this_month: 'هذا الشهر',
  finance_sets_closed: 'المفوترة فقط',
  finance_sets_closed_paid: 'مفوترة تم سدادها',
  by_accident: ' برقم الحادث',
  by_contract_id: '  برقم العقد',
  by_contract_number: ' بمعرف العقد',
  by_service_number: ' برقم الخدمة',
  by_id: ' برقم الهوية',
  by_id_and_others: ' برقم الهوية/ السجل',
  by_legal_id: 'الهوية / السجل التجاري',
  by_case: 'القضية /الدعوى',
  by_request: 'المعاملة',
  by_request_date: 'تاريخ المعاملة',
  by_case_date: 'تاريخ الدعوى',
  by_sadad: ' برقم السداد',
  by_claim: ' برقم المطالبة',
  by_policy: ' برقم الوثيقة',
  by_policy_contract: ' برقم العقد',
  by_client: ' بالعميل',
  by_serial_number: ' بالرقم التسلسلي',
  by_year: ' بسنة العلاج',
  by_hospital: ' بالمستشفى',
  by_hospital_code: ' بكود المستشفى',
  by_city: ' بالمدينة',
  by_division: ' بشعبة المرور',
  by_claim_date: ' بتاريخ التسجيل',
  by_consumer_work: ' بجهة العمل',
  by_plate: '  برقم اللوحة',
  by_mobile: ' برقم الجوال',
  by_date: ' بتاريخ الاجراء',
  mobile: 'رقم الجوال',
  mobile2: 'رقم الجوال2',
  mobile_or_mobile2_required: 'رقم الجوال او رقم الجوال2 مطلوب',
  identity_or_client_account_or_contract_id_required: 'الهوية او رقم الحساب او رقم العقد مطلوب',
  contract_id: 'رقم العقد',
  account_number: 'رقم الحساب',
  tele_claim_number: 'رقم الحساب/العقد',
  tele_client_id: 'الشركة',
  tele_client_id_entry: 'الشركة',
  identity: 'الهوية',
  contract_number: 'معرف العقد',
  nationality_id: 'الجنسية',
  required: 'غير موجود!!!',
  unique: 'مكرر!!!',
  tele_client_type_id: 'نوع العميل',
  tele_service_type_id: 'نوع الخدمة',
  tele_claim_status_id: 'حالة المطالبة',
  tele_claim_status_parent_id: 'حالة المطالبة',
  notes: 'ملاحظات',
  assigned: 'مسندة',
  by_mobile_and_others: ' برقم الجوال/الهاتف/الفاكس',
  by_claim_amount: ' بقيمة المطالبة',
  amount: 'قيمة المطالبة',
  debt_amount: 'قيمة المديونية',
  contract_amount: 'قيمة العقد',
  client_account: 'رقم الحساب',
  service_number: 'رقم الخدمة',
  attachments_size: 'حجم المرفقات',
  attachments_files: 'عدد المرفقات',
  by_name: ' بالاسم',
  non_defined: 'غير محدد',
  greg_letter: ' م',
  hijri_letter: ' هـ',
  import: 'استيراد',
  excelimport: 'ملف الإكسل',
  teleExcelImportDataEntry: 'ملف محفظة',
  teleExcelImportUpdate: 'ملف تحديث محفظة',
  teleExcelImportDeactivate: 'ملف ايقاف عقود',
  file_start_date: 'تاريخ الملف',
  persons_in_party_vehicle: 'المُرافقين ',
  add_consumer: 'إضافة مصاب',
  add_accident: 'إضافة حادث',
  entry_actions: 'إجراءات مدخل البيانات',
  add_claim: 'إضافة مطالبة',
  add_request: 'إضافة معاملة',
  view_claim: 'عرض مطالبة',
  add_close_claim: 'إضافة إغلاق تحصيل مطالبات',
  view_close_claim: 'عرض إغلاق تحصيل مطالبات',
  add_party_person: 'إضافة مرافق',
  add_party: 'إضافة طرف',
  add_party_status: 'إضافة حالة مطالبة',
  add_claim_status: 'إضافة حالة مطالبة',
  add_party_status_step: 'إضافة خطوة تنفيذ إجراء',
  view_active_claim_status: 'عرض كل الإجراءات النشطة',
  view_all_claim_status: 'عرض كل الإجراءات',
  add_car_claim_status: 'إضافة إجراء',
  client_name: 'إضافة عميل',
  add_legal_client: 'إضافة عميل',
  add_legal_case: 'إضافة قضية / دعوى',
  add_legal_party: 'إضافة طرف للدعوى',
  status_date_view: 'تاريخ إدخال الإجراء',
  is_consumer_view: 'المصاب يتبع لهذا الطرف',
  is_consumer_driver_view: 'المصاب هو سائق المركبة',
  plate_id: 'اللوحة',
  attach_document: 'المستندات',
  role: 'مجموعة الصلاحيات',
  reportsearch: 'بحث التقرير',
  reportsearch2: 'بحث التقرير',
  reportsearch3: 'اختر المستخدم',
  one_note: 'ملاحظة: ',
  last_notes: 'اخر ملاحظة: ',
  insurance_details: 'معلومات المؤمن له',
  insurance_name: 'اسم المؤمن له',
  insurance_name_1word: 'المؤمن',
  insurance_identitiy_1word: 'هوية المؤمن',
  insurance_mobile_1word: 'جوال المؤمن',
  claim_details: 'معلومات المطالبة',
  pers_details: 'المعلومات الشخصية',
  policy_claim_details: 'معلومات الوثيقة/البوليصة',
  accident_details: 'معلومات الحادث',
  accident_city: 'مدينة الحادث',
  party_details: 'الطرف الثاني',
  party_details_name: 'اسم الطرف الثاني',
  paries_details: 'أطراف الحادث',
  car_cashier_screen: 'متابعة التحصيل مركبات',
  policy_cashier_screen: 'متابعة التحصيل وثائق',
  medical_cashier_screen: 'متابعة التحصيل الطبي',
  medical_admin_screen: 'متابعة الطبي العام',
  car_claim_type1: 'شامل',
  car_claim_type2: 'ضد الغير',
  car_claim_type3: 'غير معين',
  policy_already_exists: 'رقم الوثيقة موجود مسبقاً',
  save_with_duplicate: 'حفظ مع وجود التكرار',
  import_with_duplicate: 'استيراد مع التكرار',
  contracts_count: 'عدد العقود',
  identity_claims: 'مطالبات الهوية',
  directed_claims: 'مطالبات موجهة',
  directed_to_me: 'موجهة إلي',
  directed_by_me: 'موجهة مني',
  direct_claims: 'توجيه المطالبات',
  action_done: 'تم الإجراء',
  waiting_action: 'بانتظار إجراء',
  browse_as_supervisor: 'تصفح كمشرف',
  browse_as_collector: 'التصفح كمحصل',
  back_as_collector: 'العودة كمحصل',
  all_notifications: 'عرض كل التنبيهات',
  multiple_upload: 'رفع ملفات',
  claim_status_assign_type: 'نوع اسناد الإجراء',
  assign_type1: 'إسناد خاص',
  assign_type2: 'إسناد عام',
  in_persons: 'مضاف كمرافق بحادث',
  use_in_persons: 'ربط بحادث المرافق',
  add_in_persons: 'ربط بالحادث',
  parties_numbers: {
    1: 'الأول',
    2: 'الثاني',
    3: 'الثالث',
    4: 'الرابع',
    5: 'الخامس',
    6: 'السادس',
    7: 'السابع',
    8: 'الثامن',
    9: 'التاسع',
    10: 'العاشر',
  },
  show_assistance: 'عرض المراسلة',
  edit_assistance: 'تعديل المراسلة',
  assistance_replies: 'الردود',
  add_reply: 'إضافة رد',
  add_assistance: 'مراسلات داخلية',
  close_assistance: 'إغلاق المراسلة',
  closed_assistances: 'قائمة المراسلات المغلقة',
  all_assistances: 'قائمة المراسلات',
  or: 'أو',
  delete_actions: 'حذف المحدد',
  Send2Branch2: 'إلى الفرع 2',
  GetFromBranch2: 'إلى الفرع 1',
  close_actions: 'إقفال من الشركة',
  assign_clients_for_user: 'تعيين العملاء لـ {name} ({count} عميل)',
  assign_clients_with_count: 'تعيين العملاء ({count} عميل)',
  assign_clients: 'تعيين العملاء',
  assign_client: 'تعيين عميل',
  unassign_client: 'الغاء تعيين العميل',
  assign_tele_clients_for_user: 'تعيين الشركات لـ {name} ({count} شركة)',
  assign_tele_clients_with_count: 'تعيين الشركات ({count} شركة)',
  assign_tele_clients: 'تعيين الشركات',
  assign_tele_client: 'تعيين شركة',
  unassign_tele_client: 'الغاء تعيين الشركة',
  tele_report1_tele_claim_status_row_date: 'تاريخ الاتصال',
  tele_report1_tele_claim_status_row_notes: 'ملاحظات',
  tele_report1_tele_claim_status_tele_client: 'نتيجة التواصل',
  tele_report1_tele_claim_status_field_row: 'مبلغ الوعد بالسداد',
  tele_report1_amount_after_discount: 'مبلغ السداد بعد الخصم',
  tele_report1_installments: 'عدد الاقساط',
  tele_report1_mobile: 'رقم التواصل',
  tele_report1_contract_id: 'رقم العقد',
  show_identity_claims: 'عرض مطالبات الهوية',
}
